import React from 'react';
import PropTypes from 'prop-types';
import Button from '@fff-web/fff-ui-shared/Button';
import { PriceLockStatus } from '../../pages/constants';
import styles from './styles.module.scss';

const LOCK_IN_RATE_CTA = 'PURCHASE NOW';
const EXPIRED_REACTIVATE_LINK = '/reactivate-my-membership';
const CANCELED_REACTIVATE_LINK = '/reactivate-today';

const LockInCTA = ({
  lockedRateStatus, subscriptionState, lockedRateStatusMessage, handlePurchase, buttonClicked,
}) => {
  const checkLockedRateStatus = () => (lockedRateStatus === PriceLockStatus.PAYMENT_PENDING)
    || (lockedRateStatus === PriceLockStatus.PAYMENT_PROCESSED)
    || (lockedRateStatus === PriceLockStatus.PAYMENT_FAILURE);

  const isUserCanceled = () => (subscriptionState.toUpperCase() === 'CANCELED');
  const isUserExpired = () => (subscriptionState.toUpperCase() === 'EXPIRED');
  const getReactivateLink = () => {
    if (isUserExpired()) {
      return EXPIRED_REACTIVATE_LINK;
    }
    return CANCELED_REACTIVATE_LINK;
  };

  if (isUserCanceled() || isUserExpired()) {
    return (
      <p className={styles.alreadyLockedRate} id="non-active-message">
        Oops! Your membership is
        {' '}
        {subscriptionState.toLowerCase()}
        . Please
        {' '}
        <a href={getReactivateLink()} className={styles.legalNoteLinks}>reactivate your membership</a>
        {' '}
        to lock-in the $199.99 yearly rate.
      </p>
    );
  }

  if (checkLockedRateStatus()) {
    return (
      <p className={styles.alreadyLockedRate} id="locked-message">{lockedRateStatusMessage}</p>
    );
  }

  return (
    <div className={styles.lockButtonContainer}>
      <Button
        containerFullWidth
        onClick={handlePurchase}
        disabled={buttonClicked}
      >
        {LOCK_IN_RATE_CTA}
      </Button>
    </div>
  );
};

LockInCTA.propTypes = {
  lockedRateStatus: PropTypes.string,
  subscriptionState: PropTypes.string,
  lockedRateStatusMessage: PropTypes.string,
  handlePurchase: PropTypes.func,
  buttonClicked: PropTypes.bool,
};

LockInCTA.defaultProps = {
  lockedRateStatus: '',
  subscriptionState: '',
  lockedRateStatusMessage: '',
  handlePurchase: () => true,
  buttonClicked: false,
};

export default LockInCTA;
